import { ErrorNotice } from '../components/ErrorNotice';
import type { NominationProblem } from './base-msa-shared';

/**
 * A failed base-MSA nomination — CLM-111. One presentation for both places
 * that nominate: the Base MSA page and the contract record's Set / Replace.
 *
 * **A refusal the API names is this banner, never `ErrorNotice`'s copy for its
 * kind.** That copy is written for other surfaces: a `conflict` is
 * verify-field's "Another reviewer settled this field", and a `validation`
 * says the page has a defect to report. Above a base-MSA sentence either one
 * contradicts it, so the 409 codes (`base_changed`, `already_current`,
 * `contract_changed`) and the 400 eligibility codes get their own heading and
 * body — the ClauseDetail `WriteProblem` and PipelineStatus re-run precedent.
 * A 409 is neutral and polite (`up`, `role=status`): nothing failed, the state
 * moved. A 400 takes the preview's eligibility tone.
 *
 * Anything else — a 403, a 404, a 5xx, a code this build has no words for —
 * is still `ErrorNotice`, by kind. The 404 in particular keeps its single
 * sentence, which a surface must not narrow: absent and out of scope are the
 * same answer (NFR-06).
 *
 * There is no Reload button on `base_changed`: both callers reload the base
 * as soon as the refusal lands, and the copy says so.
 */
export function NominationProblemNotice({ problem }: { readonly problem: NominationProblem }) {
  const { refusal } = problem;
  if (refusal === null) return <ErrorNotice kind={problem.kind} correlation_id={problem.correlation_id} />;
  return (
    <div className={`banner ${refusal.tone}`} role="status" data-testid="base-refusal" data-code={refusal.code}>
      <p className="notice-head">
        <strong>{refusal.head}</strong>
      </p>
      <p>{refusal.body}</p>
      {problem.correlation_id === null || problem.correlation_id === '' ? null : (
        <p className="mut">
          Correlation id <code>{problem.correlation_id}</code>
        </p>
      )}
    </div>
  );
}
